import React from "react";
import { logError } from "utils/logger";
import { QuoteForm } from "./form/QuoteForm";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm } from "react-hook-form";
import { QuoteActions } from "./QuoteActions";
import { formQuoteSchema } from "../../model/schema";
import { ConfigurationRenderProps, QuoteFormValues } from "../../types";
import { createInitialQuoteFormValue, quoteWithoutEquipment } from "../../constants/form";

interface Props extends ConfigurationRenderProps {
  onRedirect: VoidFunction;
}

export const QuoteConfiguration = ({ onRedirect, quote, isLoading, handleCreateOrUpdateQuote }: Props) => {
  const form = useForm<QuoteFormValues>({
    defaultValues: quote ? quoteWithoutEquipment(quote) : createInitialQuoteFormValue(),
    resolver: zodResolver(formQuoteSchema),
  });

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(handleCreateOrUpdateQuote, logError)}>
        <QuoteForm />
        <QuoteActions isLoading={isLoading} onCancel={onRedirect} />
      </form>
    </FormProvider>
  );
};
